/* Monogram popup customisations */

function initMonogram() {
  let monogram_popup = document.querySelector(".pplr-modal-body");

  if(monogram_popup !== null){

    let monogram_foreground_input = document.querySelector(".pplr-modal-body .pplr-enter-your-monogram input.pplr_monogram");
    let monogram_background_checkbox = document.querySelector(".pplr-modal-body .pplr-add-second-color input.pplrcheckbox");
    let paperweights_input = document.querySelector(".pplr-modal-body .pplr-icon-one");

    if(paperweights_input !== null ){
      monogram_popup.classList.add('paperweights')
    }

    const inputHandler = function(e) {
      if (paperweights_input !== null && monogram_foreground_input !== null && e.target === monogram_foreground_input) {
        const invalidCharsRegex = /[^a-zA-Z0-9&!+.\/ ]/g;
        
        let originalValue = monogram_foreground_input.value;
        let sanitizedValue = originalValue.replace(invalidCharsRegex, '');
        
        if (originalValue !== sanitizedValue) {
          monogram_foreground_input.value = sanitizedValue;
        }
      }

      let monogram_background_input = document.querySelector(".pplr-modal-body .pplr-monogram-background input.pplr_monogram");

      if (monogram_foreground_input !== null && monogram_background_input !== null && monogram_background_checkbox !== null) {
        let monogram_foreground_input_value = monogram_foreground_input.value;
        
        if(monogram_background_checkbox.checked == true){
          monogram_background_input.value = monogram_foreground_input_value;
        } else {
          monogram_background_input.value = '';
        }
        
        const event = new Event('input', { bubbles: true });
        monogram_background_input.dispatchEvent(event);
      }
    }
    
    if (monogram_foreground_input !== null) {
      monogram_foreground_input.addEventListener("input", inputHandler);
    }
    
    if (monogram_background_checkbox !== null) {
      monogram_background_checkbox.addEventListener("change", function(e) {
        setTimeout(() => {
          inputHandler(e);
        }, 50);
      });
    }
  }
}

const observer = new MutationObserver(function(mutations_list) {
  mutations_list.forEach(function(mutation) {
    if (mutation.addedNodes) { 
      mutation.addedNodes.forEach(function(added_node) {
        if(added_node.nodeType === 1 && added_node.classList.contains("pplr-modal-overlay")) {
          initMonogram();
          //observer.disconnect();
        }
      });
    }
  });
});

observer.observe(document.querySelector("body"), { subtree: false, childList: true });